export class ListJobTemplatesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "jobTemplates",
            "baseName": "jobTemplates",
            "type": "Array<JobTemplate>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListJobTemplatesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
